import 'styles/main.css';

// Need to suppress Brave from messaging "Crypto Wallet":
import { noCryptoWalletMsg } from '@itsa.io/web3utils';

noCryptoWalletMsg(); // no Brave messages, yeah!
